import { useState } from 'react';
import {
    FormControl,
    Stack,
    FormLabel,
    Box,
    Alert,
    AlertIcon,
    AlertTitle,
} from '@chakra-ui/react';
import { Field } from 'formik';
import BooleanToggle from '@/components/forms/new/formikFormFields/BooleanToggle';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';

const ActiveStatus = ({ darkMode, hasChange, setHasChange }) => {
    const [isHovered, setIsHovered] = useState(false);

    const { formData, updateFormData } = useCompanyForm();

    const handleToggleChange = (value) => {
        updateFormData(FORM_FIELD_PATHS.IS_ACTIVE, value);
        setHasChange(true);
    };

    return (
        <>
            <FormControl
                sx={{ margin: '0 !important', paddingLeft: '16px' }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}>
                <Stack
                    direction="row"
                    spacing={stackSpacing}
                    sx={{ ...stackStyling(), height: 'auto' }}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Active
                    </FormLabel>
                    <Box flex={1} maxWidth="400px">
                        <Field
                            component={BooleanToggle}
                            id="isActive"
                            name="isActive"
                            paddingTop="20px"
                            isChecked={formData?.isActive ?? false}
                            onChange={handleToggleChange}
                        />
                        {isHovered && (
                            <FieldToolTip
                                label="Enable or disable the company account"
                                ariaLabel="active-status-tip"
                                left="25px"
                                top="5px"
                            />
                        )}
                    </Box>
                </Stack>
            </FormControl>

            {!formData?.isActive && hasChange && (
                <Box mt={2} maxWidth="600px">
                    <Alert status="info">
                        <AlertIcon />
                        <AlertTitle>
                            Status is inactive! Please save your change before
                            navigating away from this page.
                        </AlertTitle>
                    </Alert>
                </Box>
            )}
        </>
    );
};

export default ActiveStatus;
